import { Card, CardContent } from "../ui/card"
import { Star } from "lucide-react"

export default function TestimonialCard({ quote, author, location, rating }) {
  return (
    <Card className="overflow-hidden transition-all duration-300 hover:shadow-md">
      <CardContent className="p-6">
        <div className="flex gap-1 mb-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              className={`h-4 w-4 ${i < rating ? "text-[#dda15e] fill-[#dda15e]" : "text-muted-foreground"}`}
            />
          ))}
        </div>
        <p className="italic mb-4">"{quote}"</p>
        <div>
          <p className="font-medium">{author}</p>
          <p className="text-sm text-muted-foreground">{location}</p>
        </div>
      </CardContent>
    </Card>
  )
}
